export class AddProjectsDialogViewModel
{
    opened: boolean = false;

    selectedListId: string | null = null;
    selectedStatusId: number | null = null;
    lists: { Id: string, Name: string }[] = [];
    statuses: { Id: number, Name: string }[] = [];


    show(lists: { Id: string, Name: string }[], statuses: { Id: number, Name: string }[])
    {
        this.lists = lists;
        this.statuses = statuses;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.selectedListId = null;
        this.selectedStatusId = null;
    }
}